import Splide from '@splidejs/splide';
import { initDialog, openDialog } from './common/dialog';
import videoRestorer from './common/video-restorer';

function setSplide(id) {
  if ($(id).length > 0) {
    let splide;

    if (window.matchMedia('screen and (min-width:992px)').matches) {
      splide = new Splide(id, {
        type: 'fade',
        pagination: false,
        arrows: false,
        drag: false,
        rewind: true,
        breakpoints: {
          991: {
            destroy: true,
          },
        },
      });
      splide.mount();
    }

    if (
      splide &&
      window.matchMedia('screen and (min-width:992px)').matches &&
      splide.state.is(Splide.STATES.DESTROYED)
    ) {
      splide.mount();
    }

    $(document).on('click', '.description-icon', function () {
      if (window.matchMedia('screen and (min-width:992px)').matches) {
        const dataid = $(this).data('id');
        $('.description-icon').removeClass('active');
        $('.description-icon[data-id="' + dataid + '"]').addClass('active');
        splide.go(dataid);
      }
    });

    $(document).on('keydown', '.description-icon', function (event) {
      if (event.key === 'Enter') {
        $(this).trigger('click');
      }
    });

    $(document).on('click', '.splide__slide', function () {
      if (window.matchMedia('screen and (max-width:991px)').matches) {
        const featureId = $(this).data('feature');
        $('.splide__slide').removeClass('active');
        $('.desc-icons-feature').addClass('hidden');
        $('.splide__slide[data-feature="' + featureId + '"]').addClass('active');
        $(this).find('.desc-icons-feature').removeClass('hidden');
      }
    });

    $(document).on('keydown', '.splide__slide', function (event) {
      if (event.key === 'Enter') {
        $(this).trigger('click');
      }
    });
  }
}

setSplide('#splide-features');
setSplide('#splide-features-2');

document.addEventListener('DOMContentLoaded', function () {
  document.addEventListener('click', event => {
    if (event.target.classList.contains('watch-video-btn')) {
      videoDatalayerEvents('v4_crash_video', 'button_click');

      const videoCrashDialog = initDialog('video-crash-dialog');
      openDialog(videoCrashDialog);
    }
  });

  if (document.querySelector('.video-crash-dialog')) {
    document.querySelector('.video-crash-dialog .youtube').addEventListener('click', function (e) {
      if (e.target.matches('img')) {
        videoDatalayerEvents('v4_crash_video', 'video_play');
      }
    });
  }

  function videoDatalayerEvents(eventName, eventAction) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      event_action: eventAction,
    });
  }
});

videoRestorer('video');
